import Billing from './billing';

export default Billing;